import { CmsComponentsBase } from '@/cmsComponents/base';
import { CmsComponentsESol } from '@/cmsComponents/esol';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...CmsComponentsBase,
  ...CmsComponentsESol,
};
